import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 26"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#6C7072",
      "fill-rule": "evenodd",
      d: "m19.475 18.888.3 1.424A4.238 4.238 0 0 1 15.8 25.5H4.2a4.237 4.237 0 0 1-3.975-5.187l.3-1.425A4.11 4.11 0 0 1 4.488 15.5h11.024a4.11 4.11 0 0 1 3.963 3.387M15.8 23.612a2.1 2.1 0 0 0 1.625-.8v.013a2.6 2.6 0 0 0 .512-2.15l-.3-1.425a2.24 2.24 0 0 0-2.125-1.887H4.489a2.24 2.24 0 0 0-2.126 1.887l-.3 1.425a2.6 2.6 0 0 0 .513 2.137 2.1 2.1 0 0 0 1.625.8zM10.625 13h-1.25a5 5 0 0 1-5-5V4.7a4.19 4.19 0 0 1 4.2-4.2h2.85a4.187 4.187 0 0 1 4.2 4.2V8a5 5 0 0 1-5 5M8.575 2.375A2.325 2.325 0 0 0 6.25 4.7V8c0 1.726 1.4 3.125 3.125 3.125h1.25c1.726 0 3.125-1.4 3.125-3.125V4.7a2.325 2.325 0 0 0-2.325-2.325z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }